import duxFactory from './fetch-dux-factory';
import * as api from '../api/api'; // TODO: rename/refactor api?

export default {
  simpleExample: duxFactory({
    apiFn: api.getTestMessage,
    actionPrefix: 'GET_TEST_MESSAGE'
  }),
  searchRestaurantsExample: duxFactory({
    apiFn: api.getRestaurants,
    actionPrefix: 'GET_RESTAURANTS'
  }),
  getRestaurantExample: duxFactory({
    apiFn: api.getRestaurant,
    actionPrefix: 'GET_RESTAURANT'
  }),
  patchRestaurantExample: duxFactory({
    apiFn: api.patchRestaurant,
    actionPrefix: 'PATCH_RESTAURANT'
  }),
  getCuisinesExample: duxFactory({
    apiFn: api.getCuisines,
    actionPrefix: 'GET_CUISINES'
  }),
  searchMusicExample: duxFactory({
    apiFn: api.getMusic,
    actionPrefix: 'GET_MUSIC'
  }),
  getAlbumExample: duxFactory({
    apiFn: api.getAlbum,
    actionPrefix: 'GET_ALBUM'
  }),
  patchAlbumExample: duxFactory({
    apiFn: api.patchAlbum,
    actionPrefix: 'PATCH_ALBUM'
  }),
  getArtistsExample: duxFactory({
    apiFn: api.getArtists,
    actionPrefix: 'GET_ARTISTS'
  }),
  login: duxFactory({ apiFn: api.postLogin, actionPrefix: 'POST_LOGIN' }),
  searchAuditLog: duxFactory({
    apiFn: api.getAuditLog,
    actionPrefix: 'GET_AUDIT_LOG'
  }),
  getType: duxFactory({
    apiFn: api.getType,
    actionPrefix: 'GET_TYPE'
  }),
  postAsset: duxFactory({
    apiFn: api.postAsset,
    actionPrefix: 'POST_ASSET'
  }),
  putAsset: duxFactory({
    apiFn: api.putAsset,
    actionPrefix: 'PUT_ASSET'
  }),
  getAsset: duxFactory({
    apiFn: api.getAsset,
    actionPrefix: 'GET_ASSET',
    successListeners: [
      'POST_PUBLISH_ASSET',
      'POST_RESTORE_ASSET',
      'PATCH_VERSION_NAME'
    ]
  }),
  getAssetsByType: duxFactory({
    apiFn: api.getAssetsByType,
    actionPrefix: 'GET_ASSETS_BY_TYPE',
    successListeners: [
      'POST_UPDATE_DISPLAY_ORDER'
    ]
  }),
  getAllTypes: duxFactory({
    apiFn: api.getAllTypes,
    actionPrefix: 'GET_ALL_TYPES'
  }),
  uploadFile: duxFactory({
    apiFn: api.uploadFile,
    actionPrefix: 'UPLOAD_FILE'
  }),
  getAllFiles: duxFactory({
    apiFn: api.getAllFiles,
    actionPrefix: 'GET_ALL_FILES',
    successListeners: [
      'POST_FOLDER',
      'UPLOAD_FILE',
      'DEL_FILE'
    ]
  }),
  postFolder: duxFactory({
    apiFn: api.postFolder,
    actionPrefix: 'POST_FOLDER'
  }),
  deleteFile: duxFactory({
    apiFn: api.deleteFile,
    actionPrefix: 'DEL_FILE'
  }),
  getTags: duxFactory({
    apiFn: api.getTags,
    actionPrefix: 'GET_TAGS'
  }),
  getAllTags: duxFactory({
    apiFn: api.getAllTags,
    actionPrefix: 'GET_ALL_TAGS'
  }),
  getTagById: duxFactory({
    apiFn: api.getTagById,
    actionPrefix: 'GET_TAG_BY_ID',
    successListeners: [
      'PUT_TAG',
      'POST_TAG'
    ]
  }),
  deleteTagById: duxFactory({
    apiFn: api.deleteTagById,
    actionPrefix: 'DELETE_TAG_BY_ID'
  }),
  putTag: duxFactory({
    apiFn: api.putTag,
    actionPrefix: 'PUT_TAG'
  }),
  postTag: duxFactory({
    apiFn: api.postTag,
    actionPrefix: 'POST_TAG'
  }),
  getAssetSiblings: duxFactory({
    apiFn: api.getAssetSiblings,
    actionPrefix: 'GET_ASSET_SIBLINGS'
  }),
  getAssetSiblingsByParent: duxFactory({
    apiFn: api.getAssetSiblingsByParent,
    actionPrefix: 'GET_ASSET_SIBLINGS_BY_PARENT'
  }),
  publishAsset: duxFactory({
    apiFn: api.publishAsset,
    actionPrefix: 'POST_PUBLISH_ASSET',
    successEmit: [
      'CLOSE_MODAL'
    ]
  }),
  restoreAsset: duxFactory({
    apiFn: api.restoreAsset,
    actionPrefix: 'POST_RESTORE_ASSET',
    successEmit: [
      'CLOSE_MODAL'
    ]
  }),
  deleteAsset: duxFactory({
    apiFn: api.deleteAsset,
    actionPrefix: 'DEL_ASSET',
    successEmit: [
      'CLOSE_MODAL'
    ]
  }),
  deleteVersion: duxFactory({
    apiFn: api.deleteVersion,
    actionPrefix: 'DEL_VERSION',
    successEmit: [
      'CLOSE_MODAL'
    ]
  }),
  patchVersionName: duxFactory({
    apiFn: api.patchVersionName,
    actionPrefix: 'PATCH_VERSION_NAME',
    successEmit: [
      'CLOSE_MODAL'
    ]
  }),
  updateDisplayOrder: duxFactory({
    apiFn: api.updateDisplayOrder,
    actionPrefix: 'POST_UPDATE_DISPLAY_ORDER',
  }),
};



// WEBPACK FOOTER //
// ./src/state/fetch-dux.js